module.exports = "<p class=\"footer\">\n   Gramvaani Community Media Pvt. Ltd.\n</p>\n"